var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-color",attrs:{"width":"21","height":"20","viewBox":"0 0 21 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.4004 12.5L10.4004 7.5L5.40039 12.5","stroke":"currentColor","stroke-width":"1.67","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }